// extracted by mini-css-extract-plugin
export default {"recipe":"recipe_recipe__2U7Ya","image":"recipe_image__HJJtc"};